import { PATHS } from '@src/consts/paths'

export const presidentCardPath: string[] = [
  PATHS.SIGNIN,
  PATHS.RESET_PASSWORD,
  PATHS.REGISTER_PASSWORD,
  PATHS.SETTINGS_ACCOUNT,
  PATHS.CARDS,
  PATHS.TRANSACTIONS,
  PATHS.EVIDENCES,
  PATHS.PAYMENTS,
  PATHS.WALLET,
  PATHS.MESSAGES,
  PATHS.CARDS_ISSUE_SELECT_TYPE,
  PATHS.CARDS_ISSUE_METAL,
  PATHS.APP,
  PATHS.DEACTIVATE_TFA,
  PATHS.OAUTH_AUTHORIZE_ACCEPT,
  PATHS.OAUTH_CONSENT_ACCEPT,
  PATHS.OAUTH_CONSENT_DECLINE,
  PATHS.OAUTH_CONSENT,
]
